import { useEffect } from 'react';
import Popup from 'reactjs-popup';
import '../styles/ImedConsentModal.css';

interface ImedConsentModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ImedConsentModal = ({ isOpen, onClose }: ImedConsentModalProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.setProperty('overflow', 'hidden', 'important');
    } else {
      document.body.style.removeProperty('overflow');
    }
    return () => { document.body.style.removeProperty('overflow'); };
  }, [isOpen]);

  return (
    <Popup
      modal
      open={isOpen}
      closeOnDocumentClick={false}
      lockScroll
      position="center center"
      className="imed-consent-popup"
    >
      <div className="imedConsentModal">
        <h2 className="imedConsentModal__title">
          Evita que tu bono quede inhabilitado
        </h2>
        <p className="imedConsentModal__text">
          Para mantener activo tu <strong>bono electrónico</strong> y poder{' '}
          <strong>realizar la compra en tu próxima cita</strong>, acepta los
          Términos y Condiciones del sistema de verificación de identidad de
          Imed.
        </p>
        <div className="imedConsentModal__buttons">
          <button
            type="button"
            className="imedConsentModal__btn imedConsentModal__btn--outline"
            onClick={onClose}
          >
            Ya lo firmé
          </button>
          <a
            href="https://consentimiento.imed.cl/invited"
            target="_blank"
            rel="noopener noreferrer"
            className="imedConsentModal__btn imedConsentModal__btn--primary"
            onClick={onClose}
          >
            Firmar ahora
          </a>
        </div>
      </div>
    </Popup>
  );
};

export default ImedConsentModal;
